import {FormError} from './FormError.js'

export class GenericFormError extends FormError {}
